export default __webpack_public_path__ + "static/media/imagenLaptopDesktop.214e39c3.png";